export { TwentyFourArrowsDirectionsRight8 } from "./TwentyFourArrowsDirectionsRight8";
